// src/components/instagram.tsx
'use client';
import { useState } from 'react';

const InstagramIcon = () => {
  const [iconColor, setIconColor] = useState('url(#paint0_linear_0_251)');

  const handleMouseEnter = () => {
    setIconColor('#FFFFFF');
  };

  const handleMouseLeave = () => {
    setIconColor('url(#paint0_linear_0_251)');
  };

  const handleClick = () => {
    setIconColor('#064E3B');
    setTimeout(() => {
      window.open('https://instagram.com/your_profile', '_blank', 'noopener,noreferrer');
    }, 500);
  };

  return (
    <div
      className="ml-3 group cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-colors duration-200"
      >
        <path
          d="M11.84 9.05C10.2936 9.05 9.04 10.3036 9.04 11.85C9.04 13.3964 10.2936 14.65 11.84 14.65C13.3864 14.65 14.64 13.3964 14.64 11.85C14.6427 11.1066 14.3485 10.3928 13.8228 9.86715C13.2972 9.34147 12.5834 9.04733 11.84 9.05Z"
          fill={iconColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.69 2H8C4.68629 2 2 4.68629 2 8V15.69C2 19.0037 4.68629 21.69 8 21.69H15.69C19.0037 21.69 21.69 19.0037 21.69 15.69V8C21.69 4.68629 19.0037 2 15.69 2ZM11.84 16.14C9.47298 16.1345 7.5555 14.217 7.55 11.85C7.54596 10.109 8.59213 8.53737 10.1998 7.86924C11.8075 7.20112 13.6595 7.56838 14.8905 8.79945C16.1216 10.0305 16.4889 11.8825 15.8208 13.4902C15.1526 15.0979 13.581 16.144 11.84 16.14ZM15.5749 6.91176C15.7462 7.31997 16.1473 7.58404 16.59 7.58C17.1865 7.58 17.67 7.09647 17.67 6.5C17.674 6.05734 17.41 5.6562 17.0018 5.48493C16.5936 5.31366 16.1223 5.40628 15.8093 5.7193C15.4963 6.03232 15.4037 6.50356 15.5749 6.91176Z"
          fill={iconColor}
        />
        <defs>
          <linearGradient
            id="paint0_linear_0_251"
            x1="2"
            y1="11.7609"
            x2="21.69"
            y2="11.7609"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#27FF7D" />
            <stop offset="1" stopColor="#18994B" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default InstagramIcon;
